export default class Attachment {
  readonly id: number
  readonly filename: string
  readonly url: string
  readonly uploadUrl: string

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.filename = data.filename
    this.url = data.url
    this.uploadUrl = data.uploadUrl
  }
}
